import { useEffect, useState } from 'preact/hooks'
import {
  getTokenFromUrl,
  clearAllSessionData,
  saveTokenToSession,
  saveIsMObywatelProcess,
} from '@/services/session'

/**
 * Session initialization hook
 *
 * Handles session setup on page load:
 * - Clears session data for fresh loads
 * - Parses and saves URL token if present
 * - Marks session as active to enable navigation
 * - Removes token from URL after processing
 *
 * @returns Object with initialization status
 */
export interface SessionInitialization {
  isInitialized: boolean
}

export function useSessionInitialization(): SessionInitialization {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (!sessionStorage.getItem('app_session_active')) {
      clearAllSessionData()
      sessionStorage.setItem('app_session_active', 'true')
    }

    const urlToken = getTokenFromUrl()
    if (urlToken) {
      saveTokenToSession(urlToken)
      saveIsMObywatelProcess(true)

      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.delete('token')
      window.history.replaceState({}, '', currentUrl.toString())
    }

    setIsInitialized(true)
  }, [])

  return {
    isInitialized,
  }
}
